import React from 'react';
import { ExternalLink, Gift, Star, TrendingUp } from 'lucide-react';
import Button from '../../../components/ui/Button';

const AffiliatePromotionPanel = () => {
  const affiliateLinks = [
    {
      id: 1,
      url: 'https://www.checkout-ds24.com/redir/549059/productsaffiliate2026/',
      title: 'Premium Products & Services',
      description: 'Exclusive deals on premium products and services tailored for your business needs.'
    },
    {
      id: 2,
      url: 'https://www.digistore24.com/redir/577408/productsaffiliate2026/',
      title: 'Digital Solutions Hub',
      description: 'Access cutting-edge digital solutions and tools to streamline your operations.'
    },
    {
      id: 3,
      url: 'https://dreamappserp.com/',
      title: 'DreamApps ERP',
      description: 'Comprehensive ERP solutions designed for modern business management.'
    }
  ];

  const handleAffiliateClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="bg-gradient-to-br from-amber-50 via-yellow-50 to-orange-50 rounded-2xl shadow-xl p-6 border-2 border-amber-200 hover:shadow-2xl transition-all duration-300 sticky top-24">
      {/* Header with Icon */}
      <div className="flex items-center gap-3 mb-4">
        <div className="p-3 bg-gradient-to-br from-amber-400 to-orange-500 rounded-xl shadow-lg">
          <Gift className="w-6 h-6 text-white" />
        </div>
        <div>
          <h3 className="text-lg font-bold text-gray-900">Partner Offers</h3>
          <p className="text-xs text-amber-700 font-medium">Exclusive Deals & Solutions</p>
        </div>
      </div>
      {/* Rating */}
      <div className="flex items-center gap-2 mb-5">
        <Star className="w-5 h-5 text-amber-500 fill-amber-500" />
        <Star className="w-5 h-5 text-amber-500 fill-amber-500" />
        <Star className="w-5 h-5 text-amber-500 fill-amber-500" />
        <Star className="w-5 h-5 text-amber-500 fill-amber-500" />
        <Star className="w-5 h-5 text-amber-500 fill-amber-500" />
      </div>
      {/* Affiliate Links Cards */}
      <div className="space-y-4 mb-5">
        {affiliateLinks?.map((link) => (
          <div
            key={link?.id}
            className="bg-white rounded-xl p-4 border border-amber-200 hover:border-amber-300 transition-all duration-200 hover:shadow-md"
          >
            <h4 className="text-base font-bold text-gray-900 mb-2">
              {link?.title}
            </h4>
            <p className="text-xs text-gray-700 leading-relaxed mb-3">
              {link?.description}
            </p>
            <Button
              onClick={() => handleAffiliateClick(link?.url)}
              className="w-full bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-600 hover:to-orange-700 text-white font-semibold py-2 px-4 rounded-lg shadow hover:shadow-lg transition-all duration-300 hover:scale-105 flex items-center justify-center gap-2 text-sm"
            >
              <span>View Offer</span>
              <ExternalLink className="w-4 h-4" />
            </Button>
          </div>
        ))}
      </div>
      {/* Benefits List */}
      <div className="space-y-2 mb-5 bg-white rounded-xl p-4 border border-amber-200">
        <div className="flex items-start gap-2">
          <TrendingUp className="w-4 h-4 text-green-600 mt-0.5 flex-shrink-0" />
          <span className="text-xs text-gray-700">Exclusive partner pricing</span>
        </div>
        <div className="flex items-start gap-2">
          <TrendingUp className="w-4 h-4 text-green-600 mt-0.5 flex-shrink-0" />
          <span className="text-xs text-gray-700">Premium quality guaranteed</span>
        </div>
        <div className="flex items-start gap-2">
          <TrendingUp className="w-4 h-4 text-green-600 mt-0.5 flex-shrink-0" />
          <span className="text-xs text-gray-700">Trusted business solutions</span>
        </div>
      </div>
      {/* Trust Badge */}
      <div className="pt-4 border-t border-amber-200">
        <p className="text-xs text-center text-gray-600">
          <span className="font-semibold">Verified Partners</span> • Secure Access
        </p>
      </div>
    </div>
  );
};

export default AffiliatePromotionPanel;